import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Button, IconButton } from "@mui/material";
import React from "react";
import DeleteAccountDialog from "./DeleteAccountDialog";
import { useHistory } from "react-router-dom";
import { getCompanyInfo, getCurrentPlan } from "@/redux/organization/selector";
import { useSelector } from "react-redux";

export default function DeleteComponent({ translationObject }: any) {
	const history = useHistory();
	const [openModal, setModalOpen] = React.useState(false);
	const companyInfo = useSelector(getCompanyInfo);
	const currentPlan = useSelector(getCurrentPlan);

	const checkDeletable = () => {
		let result = true;
		if (
			companyInfo !== null &&
			currentPlan !== null &&
			currentPlan?.paymentPlan !== null
		) {
			result =
				companyInfo?.appCount !== 0 ||
				companyInfo?.userCount > 1 ||
				currentPlan?.paymentPlan?.remainingDays > 0 ||
				companyInfo?.nextPaymentAt !== "";
		}

		return result;
	};
	const handleModalClose = () => {
		setModalOpen(false);
	};

	return (
		<div
			className="Delete"
			style={{ display: "flex", alignItems: "center", padding: "2rem" }}
		>
			<DeleteAccountDialog
				openModal={openModal}
				handleModalClose={handleModalClose}
			/>
			<div style={{ width: "70%" }}>
				<span
					style={{
						fontWeight: "bold",
						display: "inline-block",
						marginBottom: "1rem",
					}}
				>
					{translationObject("account_security_settings.delete_account")}
				</span>
				<p>
					{translationObject(
						"account_security_settings.delete_account_caution",
					)}
				</p>
			</div>

			<Button
				variant="contained"
				style={{
					width: "12rem",
					height: "2.5rem",
					marginRight: "3rem",
					backgroundColor: `${
						checkDeletable() ? "rgb(116 116 116 / 35%)" : "#E70505"
					}`,
					border: "none",
					borderRadius: "4px",
					color: `${checkDeletable() ? "#7e7e7e" : "white"}`,
				}}
				onClick={(e) => {
					setModalOpen(true);
				}}
				disabled={checkDeletable()}
			>
				{checkDeletable()
					? translationObject("account_security_settings.disable_delete")
					: translationObject("account_security_settings.enable_delete")}
			</Button>

			<IconButton
				onClick={(e) => {
					history.push("/account/delete");
				}}
			>
				<HelpOutlineIcon sx={{ color: "red" }} />
			</IconButton>
		</div>
	);
}
